import './App.css';

import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';


import Home from "./components/pages/Home";
import Footer from "./components/inc/Footer";
import Contactus from "./components/pages/Contactus";
import Brochure from './components/pages/Brochure';
import ListYourProperty from './components/pages/ListYourProperty';
import ExcNew from './components/pages/ExcNew';

import Aboutpage from './components/pages/Aboutpage';
import UnicornAerocity from './components/pages/UnicornAerocity';
function App() {
  return (
    <Router>
   
    <div>
      
      <Routes>


      <Route axact path="/" element={<Home/>}/>
      <Route axact path="/brochure-page" element={<Brochure/>}/>
      <Route axact path="/ListYourProperty" element={<ListYourProperty/>}/>
      <Route axact path="/contactus" element={<Contactus/>}/>
            <Route axact path="/aboutus" element={<Aboutpage/>}/>
                  <Route axact path="/UnicornAerocity" element={<UnicornAerocity/>}/>
          <Route axact path="/_____________exportnew__excel-lucifer" element={<ExcNew/>}/>
         
      </Routes>
 
  
    </div>
<Footer/>
    </Router>
  );
}

export default App;
